/**
 * DeleteModuleDialog - Dialog for confirming deletion of modules or submodules
 * Requires user to check confirmation checkbox to enable delete button
 */
import InputCheckbox from '../../../../../atoms/InputCheckbox/InputCheckbox';
import Dialog from '../../../../../organisms/dialogs/Dialog/Dialog';
import React from 'react';
import useDeleteModuleDialog from './useDeleteModuleDialog';

type DeleteModuleDialogProps = {
  isOpen: boolean;
  type: 'module' | 'submodule';
  onClose: () => void;
  onSuccess: () => void;
  isLoading?: boolean;
};

function DeleteModuleDialog({ isOpen, type, onClose, onSuccess, isLoading = false }: DeleteModuleDialogProps): JSX.Element {
  const { t, title, questionText, checkboxLabel, disclaimerText, buttonText, isChecked, handleCheckboxChange, handleConfirm, handleClose, isDisabled } =
    useDeleteModuleDialog({
      type,
      onClose,
      onSuccess,
      isLoading,
    });

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      size="m"
      buttonTextCancel={t('actions:Cancel')}
      buttonTextSuccess={buttonText}
      onCancel={handleClose}
      onSuccess={handleConfirm}
      isDisabledSuccess={isDisabled}
      isLoading={isLoading}
    >
      <div className="delete-module-dialog">
        <div className="delete-module-dialog__question">{questionText}</div>
        <div className="delete-module-dialog__checkbox">
          <InputCheckbox label={checkboxLabel} checked={isChecked} onChange={handleCheckboxChange} disabled={isLoading} />
        </div>
        <div className="delete-module-dialog__disclaimer">
          <span>{disclaimerText}</span>
        </div>
      </div>
    </Dialog>
  );
}

DeleteModuleDialog.propTypes = {};

DeleteModuleDialog.defaultProps = {
  isLoading: false,
};

export default DeleteModuleDialog;
